import { Component } from '@angular/core';
import { ITooltipAngularComp } from 'ag-grid-angular';
import { ITooltipParams } from 'ag-grid-community';
import { moduleRender } from '../releases.component';

@Component({
  selector: 'apps-column-view-tooltip',
  template: `<span class="lx-body">{{ apps }} </span>`,
  styleUrls: ['./apps-column-view-tooltip.component.scss']
})

export class AppsColumnViewComponentTooltip implements ITooltipAngularComp {

  apps: string;

  constructor() { }

  agInit(params: ITooltipParams): void {
    this.apps = moduleRender(params);
  }
}
